import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-school",
  "use": "icon-school-usage",
  "viewBox": "0 0 16 12",
  "content": "<symbol viewBox=\"0 0 16 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-school\">\r\n<path d=\"M3.33366 6.78667V9.45333L8.00033 12L12.667 9.45333V6.78667L8.00033 9.33333L3.33366 6.78667ZM8.00033 0L0.666992 4L8.00033 8L14.0003 4.72667V9.33333H15.3337V4L8.00033 0Z\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol